import React, { useState } from "react";
import { H2 } from "theme/components/atoms/Typography/Heading";
import Modal from "theme/components/organisms/Modal";
import IconButton from "theme/components/atoms/Button/IconButton";
import LayerFacets from "../LayerFacets";
import { useIntl, defineMessages } from "react-intl";
import LayerSorting from "../LayerSorting";

const messages = defineMessages({
  openFilters: {
    id: "modules.Layer.LayerHeader.openFilters",
    defaultMessage: "Open filters",
  },
  modalLabel: {
    id: "modules.Layer.LayerHeader.modalLabel",
    defaultMessage: "Filters",
  },
  modalTitle: {
    id: "modules.Layer.LayerHeader.modalTitle",
    defaultMessage: "Filters",
  },
});

const LayerHeader = ({ title, layer }) => {
  const intl = useIntl();
  const [areFiltersOpened, setOpenedFilters] = useState(false);
  return (
    <>
      <div className="layer-header">
        <div className="layer-header__title">
          <H2 as="h1">
            {title}&nbsp;
            <span className="layer-header__total">({layer.total})</span>
          </H2>
        </div>
        <div className="layer-header__actions">
          <div className="mobile-only">
            <IconButton
              onClick={() => setOpenedFilters(true)}
              icon="options"
              title={intl.formatMessage(messages.openFilters)}
            ></IconButton>
          </div>
          <div className="desktop-only">
            <LayerSorting appearance="standalone" />
          </div>
        </div>
      </div>
      {
        <Modal
          isOpen={areFiltersOpened}
          onRequestClose={() => setOpenedFilters(false)}
          contentLabel={intl.formatMessage(messages.modalLabel)}
          title={intl.formatMessage(messages.modalTitle)}
        >
          <LayerFacets
            layer={layer}
            applyOnChange={false}
            onSubmit={() => setOpenedFilters(false)}
            onCancel={() => setOpenedFilters(false)}
            additionalFields={({ values }) => (
              <LayerSorting
                value={{ sort: values.sort, pageLength: values.pageLength }}
              />
            )}
          />
        </Modal>
      }
    </>
  );
};

export default LayerHeader;
